export class Marcature {
    public statoDiretta: number = null;
    public minuti: number = null;
    public extratime: number = null;
    public descrizione: string = null;
    public descrizioneFull: string = null;
    public rigoriDts: boolean = false;
    public minutaggio: string = null;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/marcature.ts